<template>
  <el-dialog
    title="普通商品资料同步平台商品资料"
    :visible.sync="dialogVisible"
    width="50%"
    :before-close="handleCancel"
    >
    <div class="compare-platform">
      <div class="title">以下内容已更新，请选择同步内容和同步平台<span class="tips">（可多选）</span></div>
      <el-form :model="self_form" :rules="rules" ref="ruleForm">
         <el-form-item label="同步内容：" prop="fieldList" v-if="self_nameList.length">
            <el-checkbox-group v-model="self_form.fieldList">
              <el-checkbox v-for="item in self_nameList" :key="item.key" :label="item.key" name="type">{{item.name}}</el-checkbox>
            </el-checkbox-group>
        </el-form-item>
        <el-form-item label="同步平台：" prop="typeList">
          <div class="platforms">
            <a class="item" v-for="item in canPublishPlatform" :key="item.title" :class="{'onshelf-selected-platform': item.isChecked}" @click="chosePlatform(item)">
                <img :src="PLATFORM_ICONS_MAP[item.title]" />
                <span>{{PLATFORM_NAME_MAP[item.title]}}</span>
            </a>
          </div>
        </el-form-item>
      </el-form>
      <div v-if="tipsList.length">
        <span class="tips">注意：</span>
        <template v-for="(item, index) in tipsList">
          <div :key="item.key">
            {{`${index+1}、${tipsMap[item.key]}`}}
            <span class="text-red" v-if="item.key === 'specifications' && canPublishPlatform.find(item => item.title == '1688')">(若1688资料类目为工业类目，商品规格明细不执行同步操作)</span>
          </div>
        </template>
      </div>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="handleCancel">暂不同步</el-button>
      <el-button type="primary" @click="handleSure">确 定</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { mapGetters } from "vuex";
import {PLATFORM_ICONS_MAP, PLATFORM_NAME_MAP} from '@/dictionary/platforms';
import {getSyncPlatformItem,getBatchSyncPlatformItem} from '@/servers/prod/center/index'
import platform from '@/utils/platform';

export default {
 data() {
   let checkTypeList = (rule, value, callback)=> {
     let choosedList = this.canPublishPlatform.filter(item => item.isChecked).map(v => v.title);
     if(!choosedList.length) {
       return callback(new Error('请选择同步平台'));
     }
     callback()
  }
   return {
    PLATFORM_NAME_MAP,
    PLATFORM_ICONS_MAP,
    self_form: {
      typeList: [],
      fieldList: []
    },
    source: '',
    dialogVisible: false,
    filedNameList: [],
    canPublishPlatform: [],
    rules:{
      fieldList:[
        { required: true, message: '请选择同步内容', trigger: 'change' }
      ],
      typeList: [
        { validator: checkTypeList, required: true}
      ]
    },
    baseItemId: null,
    multipleGoods: [],
    tipsMap: {
      'title': '标题超长将跳过该字段的同步，该标题同步失败。',
      'mainImages': '同步的商品主图会直接覆盖选择的平台商品资料内商品主图。1688、抖音平台主图不得少于3张，京东平台主图不得少于5张',
      'mainImages34': '同步的3:4主图会直接覆盖选择的平台商品资料内3:4主图',
      'whiteBackGroundPic': '同步的白底图会直接覆盖选择的平台商品资料内白底图',
      'specifications': '同步的规格会覆盖当前平台资料内的规格（规格值和规格图）。如平台资料内的规格为非自定义规格或者平台资料已经解除映射关系，则同步不成功。京东和唯品会平台不支持规格图同步',
      'detailImages': '商品详情图的数量、尺寸或大小超过同步平台的要求上限，该商品详情图会铺货失败',
      'description': '商品描述同步目前只支持小红书平台',
    }
   }
 },
 computed: {
   ...mapGetters(["userInfo"]),
   self_nameList(){
     return this.filedNameList.filter(item => item.value)
   },
   tipsList(){
     return this.self_nameList.filter(item => this.tipsMap[item.key])
   }
 },
 methods: {
   method_open(filedNameList, canPublishPlatform, baseItemId, multipleGoods=[]) {
     this.dialogVisible = true;
     this.filedNameList = [...filedNameList]
     this.baseItemId = baseItemId
     this.multipleGoods = multipleGoods;
     this.canPublishPlatform = canPublishPlatform.map(item => {
       return {
         title: item,
         isChecked: false
       }
     })
   },
   chosePlatform(item) {
     if(item.isChecked) {
       item.isChecked = false
     } else {
       item.isChecked = true
     }
   },
  handleSure() {
    this.$refs.ruleForm.validate(async valid => {
      if(valid) {
        let choosedList = this.canPublishPlatform.filter(item => item.isChecked).map(v => v.title);
        let _params = {};
        let res = null;
        const isBatch = this.multipleGoods && this.multipleGoods.length > 0;
        // 单商品
        if(!isBatch){
          _params = {
            ...this.self_form,
            typeList: choosedList,
            baseItemId: this.baseItemId
          }
          res = await getSyncPlatformItem(_params);
        }else{ // 多商品
          let requestList = [];
          this.multipleGoods.forEach(obj => {
             // 商品已完善的平台和用户选择的平台取交集
            let typeList = obj.canPublishPlatform.filter(item => choosedList.includes(item));
              if(typeList.length){
                  requestList.push({
                      ...this.self_form,
                      typeList:typeList,
                      baseItemId:obj.baseItemId,
                  });
              }
          })
          _params = {
            companyId:this.userInfo.companyId,
            requestList:requestList,
          }
          res = await getBatchSyncPlatformItem(_params);
        }
        if(!res) return;
        this.$refs.ruleForm.resetFields();
        this.dialogVisible = false;
        this.$emit('abandon');
        if(!isBatch){
          if(res.result == 1 || res.result == 2) {
            this.$message.success(res.msg)
          } else {
            this.$message.error(res.msg)
          }
        }else{
            if(res.result == 1){
              this.$message.success('同步成功！')
            }else{
              this.$message.error('同步失败！')
            }
        }
      } else {
        console.log('error');
      }
    })
   },
   handleCancel() {
     this.$emit('abandon');
     this.$refs.ruleForm.resetFields();
     this.dialogVisible = false;
   }
 }
}
</script>

<style lang="scss" scoped>
  .tips{
    color: red;
  }
  .compare-platform{
    font-size: 12px;
    .title{
      margin-bottom: 12px;
    }
  }
 .platforms {
    display: flex;
    flex-direction: row;
    .item {
        display: flex;
        flex-direction: column;
        margin-right: 15px;
        cursor: pointer;
        text-decoration: none;
        color: #2c3e50;
        text-align: center;
        padding: 5px 8px;
        &.onshelf-selected-platform {
          border: 1px solid #2695FA;
          border-radius: 5px;
        }
        img {
            width: 40px;
            height: 40px;
            margin-bottom: 10px;
        }
    }
}
</style>
